import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { isTestRun2hvu4ktvvkhb7 as isTestRun } from './IsTestRun.mjs';
import { loadImages3hq91znq8rg8h as loadImages } from './components/ImagePath.mjs';
import { loadMarkdown2slzyuwbneozg as loadMarkdown } from './components/MarkdownPaths.mjs';
import { App_instance2vj33gjkobhpd as App_instance } from './App.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { json3n35pf5np6si4 as json } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
import com_zegreatrob_coupling_client_ddwm_21c35y from 'drag-drop-webkit-mobile';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function main() {
  import('/com/zegreatrob/coupling/client/animations.css');
  import('/com/zegreatrob/coupling/client/style.css');
  import('reactjs-popup/dist/index.css');
  if (isTestRun()) {
    return Unit_instance;
  }
  loadImages();
  loadMarkdown();
  configureDragDropWebkitMobile();
  App_instance.o7d();
}
function configureDragDropWebkitMobile() {
  com_zegreatrob_coupling_client_ddwm_21c35y(json([to('enableEnterLeave', true)]));
}
function mainWrapper() {
  main();
}
//region block: exports
export {
  mainWrapper as mainWrapperbo21usvk0y3y,
};
//endregion

//# sourceMappingURL=Main.mjs.map
